import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import axios from "axios";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import loadingImage from "./somarasa logo png.webp";
import { Contact } from "./contact";

export const Shop = (props) => {
  const [opacity, setOpacity] = useState(1);
  const location = useLocation();

  // State for collections
  const [collections, setCollections] = useState([]);
  const [loadingCollections, setLoadingCollections] = useState(true);

  // State for B2B products
  const [b2bProducts, setB2bProducts] = useState([]);
  const [b2bLoading, setB2bLoading] = useState(true);

  const handleScroll = () => {
    const scrollY = window.scrollY;
    const newOpacity = Math.max(1 - scrollY / 500, 0);
    setOpacity(newOpacity);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    const scrollToElement = () => {
      const hash = location.hash.replace("#", "");
      if (hash) {
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    };

    window.scrollTo(0, 0);
    scrollToElement(); // Call the function to scroll to the element

    window.addEventListener("hashchange", scrollToElement, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("hashchange", scrollToElement);
    };
  }, [location]);

  // Fetch Collections from Strapi
  const fetchCollections = async () => {
    try {
      const response = await axios.get(
        "https://somarasa-back.onrender.com/api/collections?populate=image"
      );
      console.log("API Response:", response.data); // Log the entire response
      if (response.data && response.data.data) {
        setCollections(response.data.data);
      }
      setLoadingCollections(false);
    } catch (error) {
      console.error("Error fetching collections:", error);
      setLoadingCollections(false);
    }
  };

  useEffect(() => {
    fetchCollections();
  }, []);

  useEffect(() => {
    console.log("Collections State:", collections); // Log the collections state
  }, [collections]);

  // Fetch B2B Products from Strapi
  const fetchB2BProducts = async () => {
    try {
      const response = await axios.get(
        "https://somarasa-back.onrender.com/api/b2-b-products?populate=image"
      );
      if (response.data && response.data.data) {
        setB2bProducts(response.data.data);
      }
      setB2bLoading(false);
    } catch (error) {
      console.error("Error fetching B2B products:", error);
      setB2bLoading(false);
    }
  };

  useEffect(() => {
    // fetchCollections();
    fetchB2BProducts();
  }, []);

  const [showPopup, setShowPopup] = useState(false);
  const [formData, setFormData] = useState({ name: "", email: "" });

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post(
        "https://somarasa-back.onrender.com/api/b2b-cilent-datas",
        {
          data: formData,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const link = document.createElement("a");
      link.href =
        "https://drive.google.com/uc?export=download&id=1ynf3vkMmD7JtOJFy4uP1zMO5qqrD2iqK";
      link.setAttribute("download", "filename.pdf");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setFormData({ name: "", email: "" });
      setShowPopup(false);
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const headerData = props.data?.header;
  const contactInfo = props.data?.Contact;

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  return (
    <div id="shop">
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          Somarasa Shop | Cultural Products & Traditional Arts | Handcrafted
          Items
        </title>
        <meta
          name="description"
          content="Shop unique cultural products at Somarasa. Discover handcrafted items, spiritual kits, and traditional arts celebrating Indian heritage and spirituality. Support local artisans and preserve ancient traditions with our curated collections."
        />
        <meta
          name="keywords"
          content="Somarasa shop, cultural products, handcrafted items, spiritual kits, Indian heritage, traditional arts, cultural preservation, unique gifts, Hindu culture, artisan crafts, global traditions, B2B products, business-to-business, curated collections"
        />
        <meta name="author" content="Somarasa Discoveries Private Limited" />
        <link rel="canonical" href="https://somarasa.co.in/shop" />
        <meta
          property="og:title"
          content="Somarasa Shop | Cultural Products & Traditional Arts | Handcrafted Items"
        />
        <meta
          property="og:description"
          content="Explore Somarasa's shop for unique cultural products, handcrafted items, and spiritual kits that celebrate Indian heritage. Support local artisans and preserve ancient traditions."
        />
        <meta property="og:url" content="https://somarasa.co.in/shop" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="./somarasa full logo red background.webp"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Somarasa Shop | Cultural Products & Traditional Arts | Handcrafted Items"
        />
        <meta
          name="twitter:description"
          content="Discover unique cultural products, handcrafted items, and spiritual kits at Somarasa. Our shop celebrates Indian heritage and spirituality. Support local artisans with our curated collections."
        />
        <meta
          name="twitter:image"
          content="./somarasa full logo red background.webp"
        />
      </Helmet>

      <header id="header" style={{ opacity }}>
        <div className="intro">
          <div className="overlay">
            <div className="container">
              <div className="row">
                <div className="col-md-8 col-md-offset-2 intro-text">
                  <h1>
                    {headerData ? headerData.title : "Loading"}
                    <span></span>
                  </h1>
                  <p style={{ marginBottom: "60px" }}>
                    {headerData ? headerData.paragraph2 : "Loading"}
                  </p>
                  <a
                    href="#consultancy"
                    className="btn btn-custom btn-lg page-scroll"
                  >
                    Explore
                  </a>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div id="consultancy" className="text-center">
        <div id="shop-item" className="container">
          <div className="section-title">
            <h3>Explore Our COLLECTION!</h3>
          </div>

          {/* Collection Fetching from Strapi */}
          <div className="section-title">
            {loadingCollections ? (
              <div className="loading-container">
                <img src={loadingImage} alt="Loading..." />
                <p>Loading...</p>
              </div>
            ) : (
              <div id="shop">
                <div className="container shopify-collection">
                  {collections.map((collection, index) => (
                    <a
                      href="https://thesomastore.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      key={index}
                    >
                      <div
                        id="shop-item"
                        key={index}
                        className={`row collection-row ${
                          index % 2 === 0 ? "row-left-image" : "row-right-image"
                        }`}
                      >
                        <div className="col-md-6 image-container">
                          {collection.attributes?.image?.data ? (
                            <img
                              src={
                                collection.attributes.image.data.attributes
                                  .formats?.large?.url ||
                                collection.attributes.image.data.attributes
                                  .formats?.medium?.url ||
                                collection.attributes.image.data.attributes.url
                              }
                              alt={
                                collection.attributes.title ||
                                "No title available"
                              }
                              className="collection-image img-responsive"
                            />
                          ) : (
                            <img
                              src={loadingImage}
                              alt="Image not available"
                              className="collection-image img-responsive"
                            />
                          )}
                        </div>
                        <div className="col-md-6 text-container">
                          <h4 className="collection-title">
                            {collection.attributes?.title ||
                              "No title available"}
                          </h4>
                          <p className="collection-description">
                            {collection.attributes?.description ||
                              "No description available"}
                          </p>
                        </div>
                      </div>
                    </a>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div id="b2b" className="container shop shop-b2b">
            <div className="section-title">
              <h2>Business-to-Business Products</h2>
              <Slider {...sliderSettings}>
                {b2bProducts.length > 0 ? (
                  b2bProducts.map((product, index) => (
                    <div key={index} className="slider-item">
                      {product.attributes.image.data ? (
                        <img
                          src={product.attributes.image.data[0].attributes.url}
                          alt={`Product ${index + 1}`}
                          style={{ width: "100%", height: "auto" }}
                        />
                      ) : (
                        <p>No image available</p>
                      )}
                    </div>
                  ))
                ) : (
                  <p>No products found.</p>
                )}
              </Slider>
              <div
                className="btn btn-custom-red btn-custom"
                style={{ marginTop: "25px" }}
                onClick={() => setShowPopup(true)}
              >
                Download PDF
              </div>
            </div>
          </div>

          {showPopup && (
            <div className="submission-popup">
              <div className="popup-content">
                <div className="close-btn" onClick={() => setShowPopup(false)}>
                  &times;
                </div>{" "}
                <form onSubmit={handleSubmit}>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                  <button
                    type="submit"
                    className="btn btn-custom-red btn-custom"
                  >
                    Submit and Download
                  </button>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
      <Contact data={contactInfo} />
    </div>
  );
};

export default Shop;
